<template>

  <modal :titulo="titulo" class="modal-detalhes-ato" id="detalhes-ato-registrado" :loading="loading" :fechar="true" @close="close">

    <template #actions>
      <li class="list-inline-item" v-if="!$root.isAuditorOnly && !ato.validacao">
        <a @click.prevent.stop="formulario(ato)" title="Editar"  href>
          <i class="fal fa-edit"></i>
        </a>
      </li>
    </template>

    <template v-if="!loading">

      <item-protocolo-legado tipo="ato" :id="ato.id" :dto="ato" @reload="load()" :dominio="dominio" />

      <card>
        <div class="row">
          <div class="col-3">
            <span class="mr-2 ws-title">{{descricaoProtocolo}} nº</span>{{protocoloCodigo}}
          </div>
          <div class="col-3">
            <span class="mr-2 ws-title">Registro:</span>
            <template v-if="ato.registro">{{$formatters.date(ato.registro)}}</template>
            <template v-else>-</template>
          </div>
          <div class="col">
            <span class="mr-2 ws-title">Selagem:</span>
            <template v-if="ato.selado">{{$formatters.date(ato.selado)}}</template>
            <template v-else>-</template>
          </div>

        </div>
      </card>

      <custas-container titulo="Detalhamento das Custas" tipo="ato"
                        :pagamentos="pagamentosVinculados"
                        :item="ato" :protocolo="protocolo"/>
      <div class="w-100"></div>

      <auditoria-details-content :auditoria="auditoria" :formatters="formatters" :show-after="false" :title="`Detalhes do Ato`" v-if="!loading" />

    </template>

  </modal>

</template>

<script>

import AuditoriaBusiness from "@/business/AuditoriaBusiness.js";
import FrontBusiness from "@/business/FrontBusiness.js";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness.js";
import AtoBusiness from "@/business/protocolo/AtoBusiness.js"
import ProtocoloBusiness from "@/business/protocolo/ProtocoloBusiness.js";
import CustasContainer from "@/components/Custas/CustasContainer.vue";
import DetalhesAto from "@/components/IndicadorReal/Detalhes/DetalhesAto.vue";
import AuditoriaDetailsContent from "@/v2/components/Auditoria/AuditoriaDetailsContent.vue";
import businessTipoServico from "@/views/Administracao/modulos/tipo-servico/business.js";
import {
  naturezasEscritura, naturezasLitigio, naturezasUsucapiao,
  responsaveis, opcoesAcordo
} from "@/views/Protocolo/Atos/Ato/censec-dominios.js";
import Modal from "@/components/Modal.vue";
import Card from "@/components/Layout/components/Card.vue";

import ItemProtocoloLegado from "@/views/Protocolo/Atos/Legado/ItemProtocoloLegado.vue";
import AnexosModal from "@/components/Anexos/AnexosModal.vue";
import PagamentoPosteriorBusiness from "@/business/protocolo/PagamentoPosteriorBusiness";

export default {

  name: "DetalhesAtoRegistrado",
  components: {
    AuditoriaDetailsContent,
    ItemProtocoloLegado,
    CustasContainer,
    Modal,
    Card
  },

  modal: {
    width: 900,
    escapable: false
  },

  props: {
    item: Object,
    protocoloId: String,
    ficha: Object
  },

  async mounted() {
    await this.load();
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClick);
  },

  computed: {
    chave() {
      return `detalhes-ato-registrado-card`
    },
    titulo() {
      return this.ato.id ? this.getCodigo(this.ato, this.ficha) + ' - ' + (this.ato?.tipoServico?.opcoes?.titulo || this.ato?.titulo || '') : ''
    },
    protocoloCodigo() {
      return this.ato.protocoloId || this.ato.protocolo ? this.ato.protocoloCodigo || this.ato.protocolo?.codigo : '-'
    },
    descricaoProtocolo(){
      return this.protocolo?.tipoProtocolo == "PROCESSO_INTERNO" || this.ato?.protocoloTipo == "PROCESSO_INTERNO" ? 'Processo Interno' : 'Protocolo'
    },
    possuiAreaDoi(){
      return this.areas.filter(a => a.id === 'doi').length > 0 && !this.ato.tipoServico?.opcoes?.doiOpcional;
    },
    usuario() {
      return this.$root.usuarioLogado;
    },
    auditoria(){
      return {antes: this.ato, depois : null, entidade: 'ATO', operacao : 'UPDATE'};
    },
    dominio(){
      return this.protocolo?.dominio || IndicadorBusiness.getDominioByLivro(this.ato.livro);
    }

  },

  data() {
    return {
      loading: false,
      ato: {},
      protocolo:{},
      formatters: [],
      pagamentosVinculados: []
    }
  },

  methods: {

    async formulario(ato = {}) {
      let response = await FrontBusiness.openModal(DetalhesAto, {id: ato.id, protocoloId: ato.protocoloId, ficha: this.ficha});
      this.alterouFicha = response;
      await FrontBusiness.sleep(500);
      await this.load();
    },

    async load() {
      this.loading = true;
      try {
        if (this.item?.protocoloId) {
          this.protocolo = await ProtocoloBusiness.getById(this.item.protocoloId);
        }

        this.ato = await AtoBusiness.getById(this.item.protocoloId, this.item.id || this.item.atoId);

        console.debug('ID do Ato: ', this.ato.id);

        const livro = this.ato?.livro;
        let labelsLivroIncompativel = [];
        if (['MATRICULA', 'TRANSCRICAO'].includes(livro)) {
          labelsLivroIncompativel = ['Classificação Ato Livro 3 – ITN 004', 'Denominação Complementar (Livro 3)'];
        } else if (livro === 'REGISTRO_AUXILIAR') {
          labelsLivroIncompativel = ['Classificação Ato Livro 2 – ITN 004', 'Denominação Complementar (Livro 2)', 'Classificação Ato - ITN 003'];
        }

        this.formatters = (await AuditoriaBusiness.formattersAtos(this.auditoria))
          ?.filter(f => !['Exigências', 'Protocolo', 'Etapa', 'Tipo do Ato', 'Registro', 'Selado', 'Código', 'Pedido', 'Ordem', 'Envolvidos', ...labelsLivroIncompativel].includes(f.label));

        this.formatters.push({
          label: 'Envolvidos',
          key: 'envolvidos',
          type: 'string',
          formatter: (value) => AuditoriaBusiness.envolvidos({envolvidos: value, doi: this.ato.tipoServico?.opcoes?.tipoTransacaoDoi !== 'NENHUM' && this.ato?.doi?.gerarDoi !== false })
        });

        if (this.ato.censec && Object.keys(this.ato.censec).length > 0) {
          this.formatters.push({
            label: 'CENSEC',
            key: 'censec',
            type: 'string',
            formatter: (value) => {
              const mapear = (lista, id) => lista.find(i => i.id === String(id))?.nome || id;
              const formatarMatricula = (v) => v?.replace(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{8})(\d{2})$/, '$1.$2.$3.$4.$5-$6') || v;
              const linhas = [];

              if (value.matriculaNotarialEletronica) linhas.push(`Matrícula Notarial Eletrônica: ${formatarMatricula(value.matriculaNotarialEletronica)}`);
              if (value.dataContrato) linhas.push(`Data Contrato: ${this.$formatters.date(value.dataContrato)}`);
              if (value.dataValidade) linhas.push(`Data de Validade: ${this.$formatters.date(value.dataValidade)}`);
              if (value.observacoes) linhas.push(`Observações: ${value.observacoes}`);
              if (value.naturezaEscritura) linhas.push(`Natureza Escritura: ${mapear(naturezasEscritura, value.naturezaEscritura)}`);
              if (value.naturezaLitigio) linhas.push(`Natureza Litígio: ${mapear(naturezasLitigio, value.naturezaLitigio)}`);
              if (value.acordo) linhas.push(`Acordo: ${mapear(opcoesAcordo, value.acordo)}`);
              if (value.naturezaAtaNotarialUsucapiao) linhas.push(`Natureza Ata Notarial de Usucapião: ${mapear(naturezasUsucapiao, value.naturezaAtaNotarialUsucapiao)}`);
              if (value.conjuge1) {
                const env1 = (this.ato.envolvidos || []).find(e => e.indicadorPessoalVersao?.id === value.conjuge1);
                linhas.push(`Cônjuge 1: ${env1?.nome || env1?.indicadorPessoalVersao?.nome || value.conjuge1}`);
              }
              if (value.conjuge2) {
                const env2 = (this.ato.envolvidos || []).find(e => e.indicadorPessoalVersao?.id === value.conjuge2);
                linhas.push(`Cônjuge 2: ${env2?.nome || env2?.indicadorPessoalVersao?.nome || value.conjuge2}`);
              }
              if (value.qtdFilhosMaiores != null) linhas.push(`Quantidade Filhos Maiores: ${value.qtdFilhosMaiores}`);
              if (value.qtdFilhosMenores != null) linhas.push(`Quantidade Filhos Menores: ${value.qtdFilhosMenores}`);
              if (value.responsavelFilhosMenores) linhas.push(`Responsável Filhos Menores: ${mapear(responsaveis, value.responsavelFilhosMenores)}`);

              return linhas.join('<br>');
            }
          });
        }
        await this.carregarPagamentosVinculados();

        document.addEventListener('click', this.handleClick);
      } catch (e) {
        FrontBusiness.showError('', e.message || e);
        this.close();
      } finally {
        this.loading = false;
      }

    },

    handleClick(event) {
      const element = event.target.closest('.anexos-documentos');
      if (!element) return;

      let id = element.getAttribute('data-documento-id');
      let permissao = element.getAttribute('data-permissao') === 'true';

      FrontBusiness.openModal(AnexosModal, {
        id,
        entidade: 'INDICADOR_DOCUMENTO',
        permitirEdicao: permissao,
        permiteExcluirAnexo: permissao,
        permiteIa: permissao,
        permiteTags: permissao
      });
    },

    getCodigo(ato, ficha) {
      return AtoBusiness.getCodigo(ato, ficha, ato?.tipoServico?.opcoes?.tipoAto);
    },

    fundos(linha) {
      this.$set(linha, 'detalhar', !linha.detalhar);
    },

    close() {
      FrontBusiness.closeModal(this.alterouFicha)
    },

    nomePapel(papel){ return businessTipoServico.nomePapel(papel) },

    async carregarPagamentosVinculados() {
      const protocoloId = this.protocolo?.id || this.ato?.protocolo?.id;
      if (this.$root.config?.estado !== 'RJ' || !protocoloId || !this.ato?.id) {
        this.pagamentosVinculados = [];
        return;
      }

      try {
        this.pagamentosVinculados = await PagamentoPosteriorBusiness.listarPagamentosVinculadosAtoAverbacaoCancelamentoNormalizados(
          protocoloId, this.ato.id
        );
      } catch (e) {
        this.pagamentosVinculados = [];
      }
    },

  }
}
</script>

<style lang=scss>
#detalhes-ato-registrado {
  .modal-body {
    height: calc(100vh - 150px);
  }
}
</style>
